


























import { Vue, Component, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import SendIcon from '@/components/SvgIcons/Send.vue';
import WlAvatar from '@/components/Commons/WlAvatar.vue';
@Component({
  components: {
    WlAvatar,
    SendIcon,
  },
})
export default class AddComment extends Vue {
  @Prop({}) postId;
  private commentText = '';
  async postComment({ postId, commentText }) {
    if (!this.commentText) {
      return;
    }
    vxm.users.Rudderstack.trackEvent("Forum Post Commented", {
      forumPostId : postId
        });
    await vxm.forum.postComment({ postId, commentText });
    vxm.forum.listComments({ postId, initCall: true });
    this.commentText = '';
  }
  get currentUser() {
    return vxm.users.myUserProfile;
  }
}
